
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDLKUFDDRbbi5Yrbf9p4-yxb655NUjdb78",
  authDomain: "bluepearl-e9750.firebaseapp.com",
  projectId: "bluepearl-e9750",
  storageBucket: "bluepearl-e9750.firebasestorage.app",
  messagingSenderId: "1061160236560",
  appId: "1:1061160236560:web:551a93a35d49dbacc97c95",
  measurementId: "G-D5MLGS3YXX"
};

export const app = firebase.apps.length ? firebase.app() : firebase.initializeApp(firebaseConfig);
export const db = app.firestore();
export const auth = app.auth();
export const storage = app.storage();
export const functions = app.functions();

// 🔐 CHABI NOTE (2026-07-16): admin panel ki chabi = aapka apna admin LOGIN
// (AuthProvider — email/password ya Google). Firestore rules dhandhe ke data
// par isi login ki whitelisted email maangte hain; anonymous yahan jaan-boojh
// ke NAHI hai — bina login admin data band, yahi maqsad hai.

export default firebase;